<div class="version">{{ version }}</div>

<mat-sidenav-container>
  <accredible-cookies-banner></accredible-cookies-banner>

  <!-- This is only used inside TG iframe -->
  <accredible-iframe-navigation *ngIf="showIframeNavigation"
    preview="spotlightUrl">
  </accredible-iframe-navigation>

  <header>
    <ng-container #headerContainer></ng-container>
  </header>

  <ng-container *ngIf="customBanner"
    #bannerContainer>
  </ng-container>

  <!-- TODO(Matt): Add comment explaining why we have tabindex="-1"-->
  <main id="main-content"
    tabindex="-1">
    <router-outlet></router-outlet>
  </main>

  <footer>
    <ng-container #footerContainer></ng-container>
  </footer>
</mat-sidenav-container>
